<template>
  <div class="user-resume-dialog">
    <el-dialog class=".el-dialog__header" :visible.sync="showUserResumeFlag" title="" :before-close="hideUserResume" destroy-on-close :append-to-body="true" fullscreen width="100%">
      <div id="pdfDom" style="width: 21cm;margin: 2vw auto 0;font-size: 12px;background-color: #F4F6F9">
        <div style="background-color: #1384F7;height: 40px;position: relative">
        <el-button style="position: absolute;z-index: 1;border-radius: 50%;width: 70px;height: 70px;top: 0;right:-150px;bottom: 0;margin: auto;" @click="getPdf('#pdfDom',userInfoX1.userName)">导出</el-button>
        </div>
        <div style="text-align: center;margin-top: unset">
          <img :src="userInfoX1.image" style="border-radius: 50%;width: 60px;height:60px;vertical-align: middle;margin-right: 10px;background-color: #C0C4CC">
          <h2>{{ userInfoX1.userName }}</h2>
          <p style="color: #999999">{{ userInfoX1.resumePojo.jobStatus }}</p>
          <p>
            <span style="margin:0 10px;">{{ userInfoX1.sexNum }}</span>
            |<span style="margin:0 10px;">{{ userInfoX1.age }}岁</span>
            |<span style="margin:0 10px;">{{ userInfoX1.jobExperienceName }}</span>
            |<span style="margin:0 10px;">{{ userInfoX1.residenceAddress }}</span>
          </p>
          <p>
            <span><i class="el-icon-mobile-phone">&ensp;</i>{{userInfoX1.phone}}</span><span style="margin-left: 30px"><i class="el-icon-message">&ensp;</i>{{userInfoX1.email}}xx@qq.com</span>
          </p>
        </div>
        <div>
          <h2>求职意向</h2>
          <p>{{ userInfoX1.desiredPosition }}&ensp;|&ensp;{{ userInfoX1.salaryName }}&ensp;|&ensp;{{ userInfoX1.resumePojo.city }}</p>
        </div>
        <div>
          <h2>工作/实习经历</h2>
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in userInfoX1.listJobExperiences"
              :key="index"
            >
              <dt>{{ item.startTime|dateFormat1 }}-{{ item.endTime|dateFormat1 }}</dt>
              <dd style="margin-top: 15px">
                <h3 style="text-align: left">{{ item.companyName }}</h3>
                <p><span style="color: #999999">{{ item.professionName }}&ensp;|&ensp;{{'3500-4000'}}元/月</span></p>
                <p><span style="color: #999999">职位类别：</span>{{ item.professionCategory }}<span style="color: #999999;margin-left: 150px">所述行业：</span>{{'互联网'}}</p>
                <p><span style="color: #999999">职位关键词：</span><span v-for="(item1,index1) in item.listLabel" :key="index1"
                               style="margin: 0 5px;">{{ item1.labelName }}</span></p>
                <p>{{ item.content }}</p>
              </dd>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div>
          <h2>教育经历</h2>
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in userInfoX1.listEducationExperience"
              :key="index"
            >
              <dt>{{item.startTime|dateFormat1 }}-{{ item.endTime|dateFormat1 }}</dt>
              <dd>
                <h5>{{item.schoolName}}</h5>
                <p><span>{{item.experience}}</span>&ensp;|&ensp;<span>{{item.major}}</span></p>
              </dd>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div>
          <h2>自我评价</h2>
          <p>{{userInfoX1.resumePojo.introduce}}</p>
        </div>
        <div style="background-color: #DBDBDB;height: 30px"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'UserResume3',
  props: ['showUserResumeFlag', 'userInfo'],
  data () {
    return {
      userInfoX1: this.userInfo
    }
  },
  methods: {
    hideUserResume (done) {
      this.$emit('hideUserResume')
    }
  },
  created () {
    this.userInfoX1.desiredPosition = 'hr'
  }
}
</script>

<style>
.el-dialog__header {
  padding: 0 485px;
}

.el-dialog {
  background-color: #F4F6F9;
}

.el-dialog__headerbtn {
  margin-top: -15px;
  background-color: #E3F3F3;
}
</style>

<style scoped>
#pdfDom>div{
    background-color: white;
    padding: 10px 50px;
    margin-top: 5px;
}
.title {
  font-size: 16px;
  font-weight: bold;
}

.user-resume-item {
  margin-bottom: 5px;
}

.user-resume-item-title {
  width: 75px;
  display: inline-block;
  float: left;
  color: #313131;
  font-weight: bold;
}

.user-resume-item-content {
  width: calc(100% - 75px);
  display: inline-block;
  float: left;
}

.clear {
  clear: both;
}

/deep/ .el-dialog__body {
  padding-top: 0;
}

.company-name {
  color: #313131;
  font-weight: bold;
  margin-right: 10px;
}

.work-life {
  color: #999999;
  font-size: 12px;
}

.ex-item {
  margin-bottom: 5px;
}

.edu-item {
  color: #999999;
  margin-right: 20px;
  position: relative;
}

.edu-item:not(:first-child)::before {
  position: absolute;
  content: '';
  height: 12px;
  width: 1px;
  background: #999999;
  top: 4px;
  left: -12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Recruit/UserResume3.vue